import React from 'react';
import { connect } from 'react-redux';
import { Popup } from './popup';

class LayoutBasic extends React.Component {
    render() {

        return (
            <div>                
                {this.props.children}
                <Popup />
            </div>
        );
    }

}

function mapStateToProps(state) {
  
    //To refresh layout so that sidebar and topbar is not drawn for login page when redirected to login
    let data = typeof state.router.location.state !== 'undefined' ? state.router.location.state.refresh : 'undefined'
    return {
        data
    };
}


const layoutBasic = connect(mapStateToProps)(LayoutBasic);
export { layoutBasic as LayoutBasic }; 